import React from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Flex } from 'antd'
import { ComponentDetailDiagramView } from './DiagramDetailView'
import { useDiagramDispatch } from './DiagramContext'
import { setGoBackToVehicleTest } from '../actions/go-to-vehicle-test'

const ComponentDetailDiagramPage = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const dispatch = useDispatch()
  const diagramDispatch = useDiagramDispatch()

  const vin = params.get('vin')
  const subsystemCode = params.get('subsystem_code')
  const component = params.get('component')
  const pins = params.get('pins')?.split(',').filter(Boolean) || []
  const cacheId = params.get('cache_id')

  React.useEffect(() => {
    diagramDispatch.handleVinAdded({ vin })
    if (cacheId) {
      dispatch(setGoBackToVehicleTest({ pathname: `/tracer/${cacheId}`, vin }))
    }
  }, [])

  return (
    <Flex
      className="functional-diagrams-component-detailed-diagram-container"
      vertical={true}
    >
      <ComponentDetailDiagramView
        subsystemCode={subsystemCode}
        component={component}
        pins={pins}
      />
    </Flex>
  )
}

export default ComponentDetailDiagramPage
